import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Form, Input, message } from 'antd'
import { Mail, ArrowRight, BarChart3, Shield } from 'lucide-react'
import { requiredMessage } from '../../utils/helpers'
import { logo } from '../../assets/index'
import { AUTH } from '../../utils/apis'
import { allPaths } from '../../utils/constants'
import { secureApi } from '../../Config/api'
import '../Login/LoginPage.css'

const ForgotPassword = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const [loading, setLoading] = useState(false)

    const onFinish = async (values) => {
        try {
            setLoading(true)
            const response = await secureApi.post(AUTH.FORGOT_PASSWORD, { email: values?.email })

            if (response?.success) {
                message.success(response?.message)
            } else {
                message.error(response?.message)
            }
        } catch (err) {
            message.error(err?.response?.data?.message || 'Something went wrong')
        } finally {
            setLoading(false)
        }
    }

    const gotoLogin = () => {
        history.push(allPaths.LOGIN)
    }

    return (
        <div className="login-container">
            {/* Left Side - Info Section */}
            <div className="left-section">
                <div className="left-content">
                    <div className="logo-section">
                        <div className="logo-icon">
                            <span className="logo-letter">E</span>
                        </div>
                        <div className="logo-text">
                            <div className="company-name">ELMEC</div>
                            <div className="company-subtitle">ELETTRONICA</div>
                        </div>
                    </div>

                    <div className="welcome-section">
                        <h1 className="main-heading">
                            Forgot your <br />
                            <span className="dashboard-text"> Password?</span>
                        </h1>
                        <p className="description">
                            No worries — enter your registered email and <br />
                            we’ll send you a password reset link.
                        </p>
                    </div>

                    <div className="features-section">
                        <div className="feature-card">
                            <div className="feature-icon analytics-icon">
                                <BarChart3 size={24} />
                            </div>
                            <div className="feature-content">
                                <h3 className="feature-title">Analytics</h3>
                                <p className="feature-description">Real-time insights and<br />reporting</p>
                            </div>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon security-icon">
                                <Shield size={24} />
                            </div>
                            <div className="feature-content">
                                <h3 className="feature-title">Security</h3>
                                <p className="feature-description">Enterprise-grade protection</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Side - Forgot Password Form */}
            <div className="right-section">
                <div className="login-form-container">
                    <div className="form-header">
                        <h2 className="form-title">Reset your password</h2>
                        <p className="form-subtitle">
                            Enter your email address and we’ll send you a <br />
                            link to reset your password
                        </p>
                    </div>

                    <Form name="forgot-form" onFinish={onFinish} layout="vertical" requiredMark={false} className="login-form">
                        <Form.Item
                            name="email"
                            label="Email address"
                            rules={[{ required: true, message: requiredMessage('Email') }]}
                            className="input-group"
                        >
                            <div className="input-wrapper">
                                <Mail className="input-icon" size={20} />
                                <Input
                                    name="email"
                                    placeholder="your@email.com"
                                    className="form-input"
                                />
                            </div>
                        </Form.Item>

                        <Form.Item>
                            <button
                                type="submit"
                                disabled={loading}
                                className={`submit-button ${loading ? 'loading' : ''}`}
                            >
                                {loading ? 'Sending...' : (
                                    <>
                                        Send reset link
                                        <ArrowRight size={20} />
                                    </>
                                )}
                            </button>
                        </Form.Item>
                        <p className='forgot-password-text' onClick={gotoLogin} >Already have account <span className='login-text'>login</span></p>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword
